class BESSAppInputType {
    static labelOnly = -1;
    static text = 0;
    static choice = 1;
    static boolean = 2;
    static measurement = 3;
    static percentage = 4;
    static quantity = 5;
    static textarea = 6;
    static radio = 7;
    static map = 8;
    static hidden = 9;
    static tags = 10;
}